<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane v-if="visibleSalario" key="1">
            <span slot="tab">
              <a-icon type="dollar"/>
              Salario
            </span>
        <a-card>
          <g-master name="forms"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    :parentData="parentData"
                    ref="master"
                    @action="masterAction"
                    @params="paramsTable"
          >
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
            </template>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <g-dropdown v-bind="fiOptions"
                              endpoint="coc"
                              :label="$t('Concepto')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_coc', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="filtroCocSalary"
                              ref="coc"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown v-bind="fiOptions"
                              endpoint="tsalary"
                              :label="$t('Tipo de salario')"
                              :formItemConfig="fiOptions"
                              :decorator="['tsalary', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                  >
                  </g-dropdown>
                </a-col>

                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Moneda')"
                              :formItemConfig="fiOptions"
                              :decorator="['currency', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                              :params="code_currency">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Salario')">
                    <a-input-number v-bind="fiOptions" style="width: 100%"
                                    :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                                    v-decorator="['salary', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Salario total')">
                    <a-input-number v-bind="fiOptions" style="width: 100%"
                                    :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                                    v-decorator="['salary_total', { rules: [{ required: false }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Fecha inicio vigencia')">
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD"
                                   v-decorator="['init_date', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                    ></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Fecha fin vigencia')">
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD"
                                   v-decorator="['end_date', { rules: [{ required: false}] }]"
                    ></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Fecha reporte')">
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-decorator="['date_rep', { rules: [{ required: false}] }]"
                    ></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Causa de incremento')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_increase_cause', { rules: [{ required: false}] }]"
                              :params="increase_cause">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Retroactivo')" :has-feedback="false">
                    <a-checkbox v-decorator="['retro', {valuePropName: 'checked'}]">
                    </a-checkbox>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Observación')">
                    <a-textarea autoSize
                                v-decorator="['salary_comment', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-card>
      </a-tab-pane>
      <a-tab-pane v-if="visibleGrupoSalarial" key="2">
            <span slot="tab">
              <a-icon type="team"/>
              Grupo salarial
            </span>
        <a-card>
          <employee-emp-category :empleadoseleccionado="empleadoseleccionado"></employee-emp-category>
        </a-card>
      </a-tab-pane>
    </a-tabs>
    <a-modal
      :visible="visible"
      title='Crear / Editar'
      okText='Ok'
      :confirm-loading="loading"
      @cancel="() => (visible = false)"
      @ok="editarSalary()"
    >
      <a-form-model :model="isalary" v-bind="fiOptions" :rules="formRules"
                    @submit.native.prevent ref="salaryRef">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <a-form-model-item :label="$t('Tipo de salario')" prop="tsalary" has-feedback>
              <form-model-dropdown style="width: 100%"
                                   v-model="isalary.tsalary"
                                   endpoint="tsalary"
              >
              </form-model-dropdown>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-model-item :label="$t('Moneda')" prop="currency" has-feedback>
              <form-model-dropdown style="width: 100%"
                                   v-model="isalary.currency"
                                   endpoint="hierarchy_lookup"
                                   :params="code_currency"
              >
              </form-model-dropdown>
            </a-form-model-item>
          </a-col>

          <a-col v-bind="colOptions">
            <a-form-model-item prop="salary" :label="$t('Salario')">
              <a-input-number v-bind="fiOptions" style="width: 100%"
                              v-model="isalary.salary"/>
            </a-form-model-item>
          </a-col>

          <a-col v-bind="colOptions">
            <a-form-model-item prop="total_salary" :label="$t('Salario total')">
              <a-input-number v-bind="fiOptions" style="width: 100%"
                              v-model="isalary.salary_total"/>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-model-item :label="$t('Fecha fin vigencia')" prop="end_date" has-feedback>
              <a-date-picker type="date"
                             valueFormat="Y-MM-DD HH:mm:ss" style="width: 100%"
                             v-model="isalary.end_date"/>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-model-item :label="$t('Fecha reporte')" prop="date_rep" has-feedback>
              <a-date-picker type="date"
                             valueFormat="Y-MM-DD HH:mm:ss" style="width: 100%"
                             v-model="isalary.date_rep"/>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-model-item :label="$t('Causa de aumento')" prop="id_increase_cause" has-feedback>
              <form-model-dropdown style="width: 100%"
                                   v-model="isalary.id_increase_cause"
                                   endpoint="hierarchy_lookup"
                                   :params="increase_cause"
              >
              </form-model-dropdown>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-model-item :label="$t('Retroactivo')" prop="retro">
              <form-model-checkbox v-model="isalary.retro">
              </form-model-checkbox>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-model-item v-bind="fiOptions" :label="$t('Observación')">
              <a-textarea autoSize v-model="isalary.salary_comment"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import Mensajes from '@/util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        formRules: {},
        isalary: {},
        visible: false,
        loading: false,
        code_currency: {
          h_lookup_type: 'MONEDA',
          use_code: true
        },
        increase_cause: {
          h_lookup_type: 'CAUSA_AUMENTO'
        },
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'salary',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'editar',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: () => !this.$userIsInrol('Query')
                },
                {
                  name: 'eliminar',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: () => !this.$userIsInrol('Query')
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'ID concepto', dataIndex: 'id_coc', sorter: true},
              {title: 'Concepto', dataIndex: 'coc_name', sorter: true},
              {title: 'Tipo salario', dataIndex: 'nombre_tipo_salario', sorter: true},
              {title: this.$t('Fecha reporte'), dataIndex: 'date_rep_desc', sorter: true},
              {title: 'Fecha inico vigencia', dataIndex: 'fecha_inicio', sorter: true},
              {title: 'Fecha fin vigencia', dataIndex: 'fecha_fin', sorter: true},
              {title: 'Salario', dataIndex: 'salary', sorter: true, align: 'right'},
              {title: 'Salario total', dataIndex: 'salary_total', sorter: true, align: 'right'},
              {title: 'Moneda', dataIndex: 'currency', sorter: true},
              {title: 'Motivo aumento', dataIndex: 'increase_cause', sorter: true},
              {title: 'Retroactivo', dataIndex: 'retro_desc', sorter: true},
              {title: 'Observación', dataIndex: 'salary_comment', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_coc'},
            {name: 'tsalary'},
            {name: 'currency'},
            {name: 'salary'},
            {name: 'salary_total'},
            {name: 'init_date'},
            {name: 'end_date'},
            {name: 'date_rep'},
            {name: 'id_increase_cause'},
            {name: 'retro', type: 'boolean'},
            {name: 'salary_comment'}
          ]
        },
        paramsT: {},
        endpointExcel: 'salary_/downloadExcel',
        fileNameExcel: 'SalarioEmpleado'
      }
    },
    props: ['empleadoseleccionado', 'tpay'],
    computed: {
      visibleSalario () {
        let existeParametro = this.$getConfigValue('PARAMETRIZAR_TABS_HOJA_VIDA')
        if (this.$isEmpty(existeParametro) || existeParametro === 'NO' || this.$userIsInrol('Management')) {
          return true
        } else {
          return this.$userIsInrol('HV_SALARIO')
        }
      },
      visibleGrupoSalarial () {
        let existeParametro = this.$getConfigValue('PARAMETRIZAR_TABS_HOJA_VIDA')
        if (this.$isEmpty(existeParametro) || existeParametro === 'NO' || this.$userIsInrol('Management')) {
          return true
        } else {
          return this.$userIsInrol('HV_GRUPO_SALARIAL')
        }
      },
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      },
      filtroCocSalary () {
        return {filtro_concepto_salario: true, tpay: this.tpay}
      },
      salary () {
        return this.isalary.salary
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns, ...this.parentData}
      }
    },
    mounted () {
      this.initFormRules()
      this.httpClient = new HttpUtil()
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'eliminar':
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea eliminar el registro?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().delete('salary/-1', {
                    data: {
                      id_emp: action.record.id_emp,
                      id_coc: action.record.id_coc,
                      init_date: action.record.init_date
                    }
                  })
                    .then(() => {
                      this.$refs.master.$refs.datatable.loadData()
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', 'No fue posible eliminar el registro')
                      reject(error)
                    })
                })
              },
              onCancel () { }
            })
            break

          case 'editar':
            this.visible = true
            this.isalary = {...action.record}
            break

          case 'fieldsChange':
            if (Object.keys(action.changedFields).length > 1) {
              break
            }
            if (!this.$isEmpty(action.changedFields.salary)) {
              if (this.$isEmpty(action.changedFields.salary.value)) {
                this.$refs.master.modal.form.setFieldsValue({
                  salary_total: null
                })
              } else {
                this.$refs.master.modal.form.setFieldsValue({
                  salary_total: action.changedFields.salary.value
                })
              }
            }
            break
        }
      },
      editarSalary () {
        this.loading = true
        this.$refs.salaryRef.validate(valid => {
          if (valid) {
            return new Promise((resolve, reject) => {
              this.httpClient.getInstance().put('salary/-1', {
                retro: this.isalary.retro,
                id_coc: this.isalary.id_coc,
                id_emp: this.isalary.id_emp,
                init_date: this.isalary.init_date,
                salary: this.isalary.salary,
                currency: this.isalary.currency,
                tsalary: this.isalary.tsalary,
                end_date: this.isalary.end_date,
                date_rep: this.isalary.date_rep,
                id_increase_cause: this.isalary.id_increase_cause,
                salary_total: this.isalary.salary_total,
                salary_comment: this.isalary.salary_comment
              })
                .then(() => {
                  this.$refs.master.$refs.datatable.loadData()
                  resolve()
                  this.loading = false
                  this.visible = false
                })
                .catch((error) => {
                  Mensajes.error('Error', 'No fue posible actualizar')
                  reject(error)
                  this.loading = false
                  this.visible = false
                })
            })
          }
        })
      },
      initFormRules () {
        this.formRules = {
          tsalary: [{required: true, message: 'Valor requerido'}],
          retro: [{required: false, message: 'Valor requerido'}],
          salary: [{required: true, message: 'Valor requerido'}],
          end_date: [{required: false, message: 'Valor requerido'}],
          date_rep: [{required: false, message: 'Valor requerido'}],
          id_increase_cause: [{required: false, message: 'Valor requerido'}],
          salary_total: [{required: false, message: 'Valor requerido'}],
          currency: [{required: true, message: 'Valor requerido'}],
          salary_comment: [{required: false, message: 'Valor requerido'}]
        }
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    watch: {
      salary () {
        this.isalary.salary_total = this.salary
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/EmployeeSalary.vue